import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickFilters = ({ activeFilter, onFilterChange }) => {
  const quickFilters = [
    { id: 'all', label: 'All Workouts', icon: 'LayoutGrid' },
    { id: 'favorites', label: 'Favorites', icon: 'Heart' },
    { id: 'recent', label: 'Recent', icon: 'Clock' },
    { id: 'popular', label: 'Popular', icon: 'TrendingUp' }
  ];

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 mb-4 lg:mb-6 overflow-elegant">
      {quickFilters?.map((filter) => {
        const isActive = activeFilter === filter?.id;
        return (
          <button
            key={filter?.id}
            onClick={() => onFilterChange(filter?.id)}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-lg whitespace-nowrap
              transition-smooth press-scale flex-shrink-0
              ${isActive 
                ? 'bg-primary text-primary-foreground shadow-md' 
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }
            `}
            aria-label={filter?.label}
            aria-pressed={isActive}
          >
            <Icon 
              name={filter?.icon} 
              size={18} 
              color={isActive ? 'var(--color-primary-foreground)' : 'currentColor'}
              strokeWidth={2}
            />
            <span className="text-sm font-medium caption">{filter?.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default QuickFilters;